module.exports = __webpack_public_path__ + "static/img/point_4.02d5a596.png";